import request from './request'

/**
 * 获取系统基础配置
 * @returns {Promise}
 */
export function getBasicSettings() {
  return request({
    url: '/system/basic-settings',
    method: 'get'
  })
}

/**
 * 更新系统基础配置
 * @param {Object} data 配置数据
 * @returns {Promise}
 */
export function updateBasicSettings(data) {
  return request({
    url: '/system/basic-settings',
    method: 'put',
    data
  })
}

/**
 * 获取字典列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getDictList(params) {
  return request({
    url: '/system/dicts',
    method: 'get',
    params
  })
}

/**
 * 获取字典详情
 * @param {string} code 字典编码
 * @returns {Promise}
 */
export function getDictDetail(code) {
  return request({
    url: `/system/dicts/${code}`,
    method: 'get'
  })
}

/**
 * 创建字典
 * @param {Object} data 字典数据
 * @returns {Promise}
 */
export function createDict(data) {
  return request({
    url: '/system/dicts',
    method: 'post',
    data
  })
}

/**
 * 更新字典
 * @param {string} code 字典编码
 * @param {Object} data 字典数据
 * @returns {Promise}
 */
export function updateDict(code, data) {
  return request({
    url: `/system/dicts/${code}`,
    method: 'put',
    data
  })
}

/**
 * 删除字典
 * @param {string} code 字典编码
 * @returns {Promise}
 */
export function deleteDict(code) {
  return request({
    url: `/system/dicts/${code}`,
    method: 'delete'
  })
}

/**
 * 获取字典项列表
 * @param {string} dictCode 字典编码
 * @returns {Promise}
 */
export function getDictItems(dictCode) {
  return request({
    url: `/system/dicts/${dictCode}/items`,
    method: 'get'
  })
}

/**
 * 添加字典项
 * @param {string} dictCode 字典编码
 * @param {Object} data 字典项数据
 * @returns {Promise}
 */
export function addDictItem(dictCode, data) {
  return request({
    url: `/system/dicts/${dictCode}/items`,
    method: 'post',
    data
  })
}

/**
 * 更新字典项
 * @param {string} dictCode 字典编码
 * @param {string|number} itemId 字典项ID
 * @param {Object} data 字典项数据
 * @returns {Promise}
 */
export function updateDictItem(dictCode, itemId, data) {
  return request({
    url: `/system/dicts/${dictCode}/items/${itemId}`,
    method: 'put',
    data
  })
}

/**
 * 删除字典项
 * @param {string} dictCode 字典编码
 * @param {string|number} itemId 字典项ID
 * @returns {Promise}
 */
export function deleteDictItem(dictCode, itemId) {
  return request({
    url: `/system/dicts/${dictCode}/items/${itemId}`,
    method: 'delete'
  })
}

/**
 * 获取登录日志
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getLoginLogs(params) {
  return request({
    url: '/system/logs/login',
    method: 'get',
    params
  })
}

/**
 * 获取操作日志
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getOperationLogs(params) {
  return request({
    url: '/system/logs/operation',
    method: 'get',
    params
  })
}

/**
 * 清除日志
 * @param {string} type 日志类型
 * @param {Object} params 清除参数
 * @returns {Promise}
 */
export function clearLogs(type, params) {
  return request({
    url: `/system/logs/${type}/clear`,
    method: 'post',
    data: params
  })
}

/**
 * 导出日志
 * @param {string} type 日志类型
 * @param {Object} params 导出参数
 * @returns {Promise}
 */
export function exportLogs(type, params) {
  return request({
    url: `/system/logs/${type}/export`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

/**
 * 获取数据备份列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getBackupList(params) {
  return request({
    url: '/system/backup',
    method: 'get',
    params
  })
}

/**
 * 创建备份
 * @param {Object} data 备份参数
 * @returns {Promise}
 */
export function createBackup(data) {
  return request({
    url: '/system/backup',
    method: 'post',
    data
  })
}

/**
 * 恢复备份
 * @param {string|number} id 备份ID
 * @returns {Promise}
 */
export function restoreBackup(id) {
  return request({
    url: `/system/backup/${id}/restore`,
    method: 'post'
  })
}

/**
 * 下载备份
 * @param {string|number} id 备份ID
 * @returns {Promise}
 */
export function downloadBackup(id) {
  return request({
    url: `/system/backup/${id}/download`,
    method: 'get',
    responseType: 'blob'
  })
}

/**
 * 删除备份
 * @param {string|number} id 备份ID
 * @returns {Promise}
 */
export function deleteBackup(id) {
  return request({
    url: `/system/backup/${id}`,
    method: 'delete'
  })
}

/**
 * 获取备份配置
 * @returns {Promise}
 */
export function getBackupConfig() {
  return request({
    url: '/system/backup/config',
    method: 'get'
  })
}

/**
 * 更新备份配置
 * @param {Object} data 配置数据
 * @returns {Promise}
 */
export function updateBackupConfig(data) {
  return request({
    url: '/system/backup/config',
    method: 'put',
    data
  })
}

// ==================== IP白名单管理 ====================

/**
 * 获取IP白名单列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getIPWhitelistList(params) {
  return request({
    url: '/system/ip-whitelist',
    method: 'get',
    params
  })
}

/**
 * 获取IP白名单详情
 * @param {string} id IP白名单ID
 * @returns {Promise}
 */
export function getIPWhitelistDetail(id) {
  return request({
    url: `/system/ip-whitelist/${id}`,
    method: 'get'
  })
}

/**
 * 新增IP白名单
 * @param {Object} data IP白名单数据
 * @returns {Promise}
 */
export function createIPWhitelist(data) {
  return request({
    url: '/system/ip-whitelist',
    method: 'post',
    data
  })
}

/**
 * 更新IP白名单
 * @param {string} id IP白名单ID
 * @param {Object} data IP白名单数据
 * @returns {Promise}
 */
export function updateIPWhitelist(id, data) {
  return request({
    url: `/system/ip-whitelist/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除IP白名单
 * @param {string} id IP白名单ID
 * @returns {Promise}
 */
export function deleteIPWhitelist(id) {
  return request({
    url: `/system/ip-whitelist/${id}`,
    method: 'delete'
  })
}

/**
 * 批量删除IP白名单
 * @param {Array} ids IP白名单ID数组
 * @returns {Promise}
 */
export function batchDeleteIPWhitelist(ids) {
  return request({
    url: '/system/ip-whitelist/batch',
    method: 'delete',
    data: { ids }
  })
}

/**
 * 启用/禁用IP白名单
 * @param {string} id IP白名单ID
 * @param {string} status 状态 active/disabled
 * @returns {Promise}
 */
export function updateIPWhitelistStatus(id, status) {
  return request({
    url: `/system/ip-whitelist/${id}/status`,
    method: 'patch',
    data: { status }
  })
}

/**
 * 检查IP是否在白名单中
 * @param {string} ip IP地址
 * @returns {Promise}
 */
export function checkIPWhitelist(ip) {
  return request({
    url: '/system/ip-whitelist/check',
    method: 'post',
    data: { ip }
  })
}

/**
 * 导出IP白名单
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function exportIPWhitelist(params) {
  return request({
    url: '/system/ip-whitelist/export',
    method: 'get',
    params
  })
} 